<template>
  <v-form ref="ResetForm" v-model="valid" lazy-validation>
    <v-card width="400" height="400" align="center" class="cardReset">
      <v-card-title>{{ $t("forgotPassword.resetPassword") }}</v-card-title>

      <v-card-text>
        <v-text-field
          v-model="password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show1 ? 'text' : 'password'"
          @click:append="show1 = !show1"
          :error-messages="passwordErrors"
          :label="$t('forgotPassword.password')"
          required
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        ></v-text-field>

        <v-text-field
          v-model="confirmPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show2 ? 'text' : 'password'"
          @click:append="show2 = !show2"
          :error-messages="confirmErrors"
          :label="$t('forgotPassword.passwordConfirmation')"
          required
          @input="$v.confirmPassword.$touch()"
          @blur="$v.confirmPassword.$touch()"
          class="my-4"
        ></v-text-field>
      </v-card-text>

      <div v-if="errorPassword.checkPassword">
        {{ errorPassword.checkPassword }}
      </div>

      <v-card-actions class="justify-center cardActionReset">
        <v-btn
          :disabled="
            !valid ||
            password.length == 0 ||
            confirmPassword.length == 0 ||
            password != confirmPassword
          "
          color="primary"
          @click="submitPassword()"
        >
          {{ $t("forgotPassword.continue") }}
        </v-btn>
        <v-btn color="primary" :to="'/'">
          {{ $t("forgotPassword.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import router from "@/router/index";
import VueRecaptcha from "vue-recaptcha";
import { validationMixin } from "vuelidate";
import {
  required,
  minLength,
  maxLength,
  sameAs,
  helpers,
} from "vuelidate/lib/validators";
import resetService from "@/services/planning/ResetService";
import ResetPassword from "@/models/ResetPassword";

const alpha = helpers.regex(
  "alpha",
  /^(?=.*[a-z])(?=.*[A-ZÀ-ȕ])(?=.*[0-9])(?=.*[\(\)\,\-\_\.\, !@#\$%\^&\*])/
);

export default {
  mixins: [validationMixin],

  validations: {
    password: { required, alpha, minLength: minLength(8) },
    confirmPassword: {
      required,
      minLength: minLength(8),
      sameAsPassword: sameAs("password"),
    },
  },

  components: {
    VueRecaptcha,
  },

  data: () => ({
    show1: false,
    show2: false,
    password: "",
    confirmPassword: "",
    status: "",
    sucessfulServerResponse: "",
    serverError: "",
    valid: false,
    token: "default",
    errorPassword: { checkPassword: null },
  }),

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(this.$t("errorFrontEnd.shortPassword"));
      !this.$v.password.required &&
        errors.push(this.$t("errorFrontEnd.requiredPassword"));
      !this.$v.password.alpha &&
        errors.push(this.$t("errorFrontEnd.invalidPasswordLenght"));
      return errors;
    },
    confirmErrors() {
      const errors = [];
      if (!this.$v.confirmPassword.$dirty) return errors;
      !this.$v.confirmPassword.sameAsPassword &&
        errors.push(this.$t("errorFrontEnd.identicalPassword"));
      return errors;
    },
  },

  created() {
    this.getUrlToken();
  },

  methods: {
    getUrlToken() {
      if (this.$route.query.token) this.token = this.$route.query.token;
      else if ((this.token = "default")) router.push("/" + this.$i18n.locale);
    },

    submitPassword() {
      const resetpassword = new ResetPassword(this.token, this.password);
      resetService.reset(resetpassword).then((data) => {
        if (data.status == 500) {
          this.errorPassword.checkPassword = this.$t(
            "forgotPassword.errorToken"
          );
        } else if (data.status != 200) {
          this.errorPassword.checkPassword = this.$t(
            "forgotPassword.invalidPassword"
          );
        } else {
          this.errorPassword.checkPassword = this.$t(
            "forgotPassword.updatedPassword"
          );
          setTimeout(() => router.push("/" + this.$i18n.locale), 5000);
        }
      });
    },
  },
};
</script>

<style>
#styled-input {
  height: 40px;
  font-size: 15pt;
}
.styled-input label[for] {
  height: 40px;
  font-size: 15pt;
}

.cardReset {
  padding: 2rem 2rem;
}

.button {
  width: 100%;
}

.cardAction {
  padding: 0 1rem;
}

.cardActionReset {
  padding: 1rem;
}

.v-application .title {
  font-size: 1.5rem !important;
  justify-content: center;
}
</style>
